<template>
  <div class="modal fade" id="contactFormModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body p-0">
          <div class="row no-gutters">
            <!-- 左侧logo部分 -->
            <div class="col-md-6 d-flex align-items-center justify-content-center bg-light">
              <div class="p-4 text-center">
                <img src="@/assets/images/logo_da.png" alt="Logo" class="img-fluid mb-4" style="max-height: 150px;">
                <h4>On-site Experiences, Virtual Sessions,
                    Webinars, Live Learning Events</h4>
                <p class="text-muted">Fill out the form to get started</p>
              </div>
            </div>
            
            <!-- 右侧表单部分 -->
            <div class="col-md-6">
              <div class="p-4">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                
                <h4 class="mb-4 text-center">Start Learning</h4>
                
                <form @submit.prevent="submitForm">
                  <div class="form-group">
                    <label>What's the primary need you are looking for?</label>
                    <select class="form-control" v-model="form.primaryNeed" required>
                      <option value="">Please Select</option>
                      <option value="IELTS Test Prep. & Learning">IELTS Test Prep. & Learning</option>
                      <option value="Clock-In Learning for Postgraduate">Clock-In Learning for Postgraduate</option>
                      <option value="Preliminary & Vantage Learning">Preliminary & Vantage Learning</option>
                      <option value="Complaints & Business Proposals">Complaints & Business Proposals</option>
                    </select>
                  </div>
                  
                  <div class="form-group">
                    <label>Message</label>
                    <textarea class="form-control" v-model="form.message" rows="3"></textarea>
                  </div>
                  
                  <div class="form-group">
                    <label>How did you hear about Vokapular in the first place?</label>
                    <select class="form-control" v-model="form.hearAbout" required>
                      <option value="">Please Select</option>
                      <option value="TikTok Live Streaming">TikTok Live Streaming</option>
                      <option value="Keywords Search">Keywords Search</option>
                      <option value="Recommendation from a friend">Recommendation from a friend</option>
                      <option value="Others">Others</option>
                    </select>
                  </div>
                  
                  <div class="form-group">
                    <label>Contact Us</label>
                    <input type="text" class="form-control" v-model="form.contactInfo" required>
                  </div>
                  
                  <button type="submit" class="btn btn-primary btn-block">Submit</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactFormModal',
  data() {
    return {
      form: {
        primaryNeed: '',
        message: '',
        hearAbout: '',
        contactInfo: ''
      }
    }
  },
  methods: {
    show() {
      $('#contactFormModal').modal('show');
    },
    showToast(type, message) {
      // 修改toast的调用方式
      if (type === 'success') {
        this.$toast.success(message);
      } else if (type === 'error') {
        this.$toast.error(message);
      }
    },
    submitForm() {
      this.$http.post('/users/contact-form', this.form)
        .then(() => {
          this.showToast('success', '表单提交成功！');
          // $('#contactFormModal').modal('hide');
          this.$emit('close');
        })
        .catch(error => {
          const errorMsg = error.response && error.response.data && error.response.data.message || '提交失败，请稍后再试';
          console.error('提交表单时出错:', error);
          this.showToast('error', errorMsg);
        });
    }
  }
}
</script>

<style scoped>
.modal-dialog {
  max-width: 800px;
  max-height: 600px;
}

.modal-content {
  border-radius: 10px;
  overflow: hidden;
}

.no-gutters {
  margin-right: 0;
  margin-left: 0;
}

.no-gutters > .col,
.no-gutters > [class*="col-"] {
  padding-right: 0;
  padding-left: 0;
}
</style>